import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { VrstaDokumenta } from './vrsta-dokumenta';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-vrsta-dokumenta-modal-update',
  templateUrl: './vrsta-dokumenta-modal-update.component.html'
})
export class VrstaDokumentaModalUpdateComponent extends BaseModalUpdateComponent<VrstaDokumenta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaDokumenta>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
